import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class ShipperService {
    baseUrl: string = 'Shipper.svc';    
    constructor(private http: Http, private _ajaxService: AjaxService) {
    }
    save(dataToBePost) {        
        return this._ajaxService.POST(this.baseUrl + "/save", dataToBePost);        
    }
    delete(id) {        
        return this._ajaxService.GET(this.baseUrl + "/delete/" + id);        
    }
    select(id) {        
        return this._ajaxService.GET(this.baseUrl + "/select/"+id);        
    }
    all(pageIndex,pageSize,sortHeaderName,sortDirection,filterText) {        
        return this._ajaxService.GET(this.baseUrl + "/all/" + pageIndex + "/" + pageSize + "/" + sortHeaderName + "/" + sortDirection + "/" + filterText);        
    }
    selectCode(code) {
        return this._ajaxService.GET(this.baseUrl + "/selectCode/" + code);
    }
    list(id){
        return this._ajaxService.GET(this.baseUrl + "/list/" + (typeof id == "undefined" ? 0 : id) + "/ /0");
    }
}




// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/shipper.service.ts